import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {checkQueryKey, formatTime, stringAvatar} from "@/helper/method";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {PatentPageVO, useQueryPatentPage} from "@/service/patent.s";
import {useAuthInfo} from "@/store/account.c";
import {WritePatent} from "@/pages/Patent/WritePatent";
import {useParams} from "react-router-dom";
import {useEffect, useMemo} from "react";
import {ViewPatent} from "@/pages/Patent/ViewPatent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {Avatar, ButtonGroup} from "@mui/material";
import Button from "@mui/material/Button";
import {NavigateBefore, NavigateNext} from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import {useCreateMonitor} from "@/service/monitor.s";
import {useGlobalActions} from "@/store/global.c";
import {defaultPageParams, permScope, roleAlias} from "@/helper/constant";
import {useClaimProduct, useTransferProduct} from "@/service/contract.s";
import {WriteStatus} from "@/widget/WriteStatus/ReviewStatus";
import {TransferForm, WriteTransferForm} from "@/widget/TransferForm/TransferForm";
import {find, findIndex} from "lodash";
import isEmpty from "lodash/isEmpty";
import {useRoleUsers} from "@/store/user.c";
import {SellerAvatar} from "@/widget/SellerAvatar/SellerAvatar";

const patentCode: { [key: string]: string } = {
    'caseWhse': "case_whse",
    "unclaim": "unclaim_case",
    "duty": "duty_case",
}

const patentStatus: { [key: string]: number } = {
    'caseWhse': 0,
    "unclaim": 5,
    "duty": 6,
}

const initPage = (page: string): [number, string] => {
    return [patentStatus[page], patentCode[page]]
}

export const PatentListPage = () => {
    const {page} = useParams()
    const [writeStatus, code] = initPage(page!)
    const {
        mutate: patentPageMutate,
        data: patentPageData,
        isPending: patentPagePending,
        isIdle
    } = useQueryPatentPage(writeStatus)
    const {setToast, setDialogModal} = useGlobalActions()
    const {mutateAsync: creatorMonitorMutate} = useCreateMonitor()
    const {mutateAsync: claimProductMutate} = useClaimProduct()
    const {mutateAsync: transferProductMutate} = useTransferProduct()
    const users = useRoleUsers(["patenter", "processer"])
    const {id: authId, role: {dataScope, roleAlias: alias}} = useAuthInfo()

    const allColumns: GridColDef<PatentPageVO>[] = [
        {
            field: "patentName",
            headerName: "专利名称",
            headerAlign: "left",
            align: "left",
            flex: 0.58,
            valueFormatter: (value: string) => {
                return value || "待定"
            }
        },
        {
            field: "category",
            headerName: "申请类型",
            headerAlign: "left",
            align: "left",
            flex: 0.45,
            valueFormatter: (value: string) => value || "-"
        },
        {
            field: "isMonitor",
            headerName: "年费监控",
            headerAlign: "left",
            align: "left",
            flex: 0.45,
            renderCell: ({row}) => {
                if (row.isMonitor == 1) {
                    return <Chip label={'监控中'} color={'success'}/>
                }
                return <Chip label={'未监控'} color={'error'}/>
            }
        },
        {
            field: "applyNo",
            headerName: "申请号/专利号",
            headerAlign: "left",
            align: "left",
            flex: 0.4,
            valueFormatter: (value: string) => value || "-"
        },
        {
            field: "applyDate",
            headerName: "申请时间",
            flex: 0.4,
            valueFormatter: (value: string) => formatTime("D", value) || "-"
        },
        {
            field: "patentStatus",
            headerName: "案件状态",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            display: "flex",
            valueFormatter: value => value || "未申请",
            renderCell: ({row}) => <Typography textOverflow={'ellipsis'} overflow={'hidden'} color={'warning'}>{row.patentStatus || "-"}</Typography>
        },
        {
            field: "writer",
            headerName: "撰稿人",
            headerAlign: "center",
            align: "center",
            flex: 0.35,
            display: 'flex',
            valueFormatter: (value: string) => value || "-"
            // renderCell: ({row}) => <Avatar {...stringAvatar(row.writer || "待分配")} />
        },
        {
            field: "writeStatus",
            headerName: "撰稿状态",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
            display: "flex",
            renderCell: ({row}) => {
                return <WriteStatus writeStatus={row?.writeStatus} writeStatusId={row?.writeStatusId}/>
            }
        },

        {field: "customerName", headerName: "客户名称", flex: 0.5},
        {
            field: "seller",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            flex: 0.45,
            display: "flex",
            valueGetter: (_, row) => ({creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "createdAt",
            headerName: "内部期限",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            valueFormatter: (value) => formatTime("D", value),
        },
        // {
        //     field: "nodeNames",
        //     headerName: "审核状态",
        //     headerAlign: "center",
        //     align: "center",
        //     renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={id} writeStatusId={row.writeStatusId} auditStatus={row.auditStatus}
        //                                          nodeNames={row.nodeNames}/>,
        // },

    ];

    const dutyColumns: GridColDef<PatentPageVO>[] = [
        {
            field: "patentName",
            headerName: "专利名称",
            flex: 0.7,
            valueFormatter: (value: string) => value || "待定"
        },
        {
            field: "category",
            headerName: "申请类型",
            headerAlign: "left",
            align: "left", flex: 0.6
        },
        {
            field: "applyNo",
            headerName: "申请号/专利号",
            headerAlign: "left",
            align: "left", flex: 0.6,
            valueFormatter: value => value || "-"
        },

        {
            field: "customerName",
            headerName: "客户名称",
            flex: 0.7
        },
        {
            field: "seller",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            display: "flex",
            valueGetter: (_, row) => ({creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "patentStatus",
            headerName: "案件状态",
            headerAlign: "center",
            align: "center",
            valueFormatter: value => value || "-"
        },
        {
            field: "insideDeadline",
            headerName: "内部期限",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
        {
            field: "receiveTime",
            headerName: "领取时间",
            headerAlign: "right",
            align: "right",
            valueFormatter: (value) => formatTime("D", value),
        },
    ]

    const unclaimColumns: GridColDef<PatentPageVO>[] = [
        {
            field: "kind",
            headerName: "服务名称",
            headerAlign: "left",
            align: "left", flex: 0.5,
            valueFormatter: (value: string) => value || '-'
        },
        {
            field: "category",
            headerName: "申请类型",
            headerAlign: "left",
            align: "left",
            flex: 0.4,
            valueFormatter: (value: string) => value || '待定'
        },
        {
            field: "customerName",
            headerName: "客户名称",
            flex: 0.8
        },
        {
            field: "seller",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            display: 'flex',
            flex: 0.4,
            valueGetter: (_, row) => ({creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "price",
            headerName: "价格",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "insideDeadline",
            headerName: "内部期限",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
        {
            field: "assigner",
            headerName: "分配人",
            headerAlign: "right",
            align: "right",
        },
        {
            field: "assignTime",
            headerName: "分配时间",
            headerAlign: "right",
            align: "right",
            valueFormatter: (value) => formatTime("D", value),
        },
    ]

    useEffect(() => {
        if (isIdle == false) {
            patentPageMutate({current: 1, size: 20})
        }
    }, [writeStatus]);


    const columns = useMemo(() => {
        switch (writeStatus) {
            case 0:
                return allColumns
            case 5:
                return unclaimColumns
            case 6:
                return dutyColumns
        }
        return []
    }, [writeStatus]);

    const submitTransferCallback = async (productTypeId: number, keys: number[], onSearch?: (params: any) => void, values?: WriteTransferForm) => {
        const result = await transferProductMutate({ids: keys, productTypeId, writer: values!.username!, writerId: values!.userId!})
        if (result.code == 0) {
            onSearch && onSearch(defaultPageParams)
            setToast({message: result.msg, open: true, severity: 'success'})
            setDialogModal({open: false})
        } else {
            setToast({message: result.msg, open: true, severity: 'error'})
        }
    }

    const btnCallback = async ({btn, onSearch, keys, rows}: BtnType<PatentPageVO>) => {
        if (btn.alias == "transfer") {
            if (keys.length <= 10 && keys.length > 0) {
                const project = find(rows, (row: PatentPageVO) => row.writerId != authId);
                if (!isEmpty(project)) {
                    setToast({message: "选择的记录存在不属于你撰写的专利,请取消不是你撰写的专利再试", open: true, severity: 'warning'})
                    return
                }
                const content: string = rows.map((row: PatentPageVO) => `${row.customerName}:${row.category}`)?.join(",")
                setDialogModal({
                    header: btn.menuName,
                    maxWidth: 'xs',
                    body: <TransferForm content={content} submitCallback={(values: WriteTransferForm) => submitTransferCallback(1, keys, onSearch, values)} users={users}
                                        ids={keys}/>,
                    open: true,
                    onSearch
                })
            } else {
                setToast({message: "请选择1至10条数据", open: true, severity: 'warning'})
            }
            return
        }
        if (btn.code == "join_monitor") {
            if (keys.length >= 1 && keys.length <= 30) {
                const index = findIndex(rows, (item: PatentPageVO) => isEmpty(item.applyDate) || !checkQueryKey(item.categoryId) || item.isMonitor == 1)
                if (index > -1) {
                    setToast({
                        open: true,
                        message: "选择的记录中存在未填写申请时间或申请类型或已加入年费监控的案件，请重新选择",
                        duration: 5,
                        severity: 'warning',
                        variant: 'standard'
                    })
                    return
                }
                const result = await creatorMonitorMutate({ids: keys})
                if (result.code == 0) {
                    setToast({open: true, message: result.msg, severity: 'success', variant: 'standard'})
                    onSearch && onSearch(defaultPageParams)
                }
            } else {
                setToast({open: true, message: "请选择一至三十条数据", severity: 'warning', variant: 'standard'})

            }
            return
        }
        if (btn.alias == "claim") {
            if (keys.length <= 10 && keys.length > 0) {
                const result = await claimProductMutate({ids: keys, productTypeId: 1})
                if (result.code == 0) {
                    onSearch && onSearch(defaultPageParams)
                    setToast({message: result.msg, open: true, severity: 'success'})
                }
            } else {
                setToast({message: "请选择1至10条数据", open: true, severity: 'warning'})
            }
            return
        }
    }

    return (
        <ProTable<PatentPageVO>
            loading={patentPagePending}
            columnVisibilityModel={{
                seller: !(alias == roleAlias["marketing"] && dataScope == permScope['self']),
                writer: !((alias == roleAlias["processer"] || alias == roleAlias["patenter"]) && dataScope == permScope['self'])
            }}
            renderDrawer={{view: <ViewPatent/>, write: <WritePatent/>}}
            columns={columns}
            btnCallback={btnCallback}
            fieldKey={'id'}
            drawerProps={{
                view: {
                    bodyWidth: 620, headerHeight: 68, hiddenFooter: true, viewBtnCallback: (row: PatentPageVO) => {
                        return {
                            custom: true,
                            title: row.patentName || "待定",
                            businessId: row.contractId,
                            switchButton: <ButtonGroup size={'small'} sx={{
                                "& .MuiButton-startIcon": {marginRight: 0},
                                "& .MuiButton-endIcon": {marginLeft: 0}
                                , "& .MuiButtonGroup-grouped": {minWidth: 20, height: 20, width: 12, bgcolor: '#f2f4fb',}
                            }} variant="outlined">
                                <Button size={'small'} startIcon={<NavigateBefore/>}/>
                                <Button size={'small'} endIcon={<NavigateNext/>}/>
                            </ButtonGroup>,
                            icon: <TipsAndUpdatesOutlinedIcon color={'info'} fontSize={'small'}/>,
                            tags: <Stack direction={'row'} spacing={1.4} alignContent={'center'}>
                                <Chip size={'small'} variant={'outlined'} sx={{height: 16}} color={'warning'} label={<Typography fontSize={10}>{row.patentStatus}</Typography>}/>
                                <Chip sx={{height: 16}} size={'small'} variant={'outlined'} color={'error'} label={<Typography fontSize={10}>{row.kind}</Typography>}/>
                                <Chip sx={{height: 16}} size={'small'} variant={'outlined'} color={'success'} label={<Typography fontSize={10}>{row.category}</Typography>}/>
                                <Chip sx={{height: 16}} size={'small'} variant={'outlined'} color={'info'} label={<Typography fontSize={10}>{row.writeStatus}</Typography>}/>
                            </Stack>, instanceId: row.instanceId
                        }
                    }
                }
            }}
            data={patentPageData?.data}
            onSearch={(params) => {
                patentPageMutate(params);
            }}
            code={code}
        />
    );
};
